import { ProductFrame } from '@/components/marketing/product-frame'

export function RunDetailFrame() {
  return (
    <ProductFrame url="uptrack.app/dashboard/monitors/checkout-flow/browser-runs/run-0">
      <img
        src="/screenshots/run-detail.webp"
        alt="The stepped replay of a failed run: four steps, the first three passed, step 4 timed out waiting for the pay button."
        width={1184}
        height={800}
        loading="lazy"
        className="block h-auto w-full"
      />
    </ProductFrame>
  )
}
